// extracted by mini-css-extract-plugin
export default {"container":"styles_container__j2XL6","header":"styles_header__rRLoD","mainInfo":"styles_mainInfo__VVZar","loading":"styles_loading__Fzk+o","spin":"styles_spin__Ez0K-"};